import InputSelect from "@/components/input-select/InputSelect";
import ScanCode from "../../../components/ScanCode";
import { literals } from "@/constants/literals";
import { EXITS_STEPS } from "@/constants/selectsLists";
import type { ExitsSearchData } from "../CreateExits";

export type GetInfoInputsProps = {
  exitsData: ExitsSearchData;
  changeData: (property: string, value: string) => void;
  searchAgainMsg?: boolean;
};
const GetInfoInputs = ({
  exitsData,
  changeData,
  searchAgainMsg,
}: GetInfoInputsProps) => {
  return (
    <div className="w-full md:flex md:flex-row md:gap-x-4">
      <div className="max-md:w-full mb-4 md:flex-1">
        <InputSelect
          size="medium"
          label={literals.step}
          id="step"
          name="step"
          options={EXITS_STEPS}
          onChange={(new_value) => changeData("step", new_value)}
          value={exitsData.step}
          required
          placeholder={literals.chooseAnOption}
        />
      </div>
      <div className="max-md:w-full md:flex-1">
        <ScanCode
          label={literals.docu9R1}
          value={exitsData.document9r1}
          onChange={(new_value) => changeData("document9r1", new_value)}
          codeType="docu9R1"
          searchAgainMsg={searchAgainMsg}
          noMargingButtom
        />
      </div>
    </div>
  );
};

export default GetInfoInputs;
